import { css, styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Ruler = styled.hr<{
  $tighterOnMobile?: boolean;
  $maxWidth?: string;
  $centered?: boolean;
}>`
  border: none;
  border-top: 1px solid var(--swatch1);
  margin: ${(props) =>
    `${props.theme.spacing.s} ${props.$centered ? "auto" : "0"}`};
  max-width: ${(props) => props.$maxWidth || "320px"};

  ${(props) =>
    props.$tighterOnMobile &&
    css`
      @media (max-width: ${mobileBreakPointCSS}) {
        margin: ${(props) => props.theme.spacing.xs} 0;
      }
    `}
`;
